import * as React from 'react';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {Icon} from '../Icon/Icon';
import * as supportIcon from '../../../assets/Support.svg';

import * as Styles from './Footer.module.scss';

export interface Option {
    name: string;

    /**
     * Options are selectable by default, set this to false to convert the option to static text
     */
    selectable?: boolean;

    /**
     * Only applies if option is selectable
     */
    action?: () => void;
}

interface Props {
    title?: string;
    options?: Option[];
}

export const Footer: React.FC<Props> = (props) => {
    const {title, options = []} = props;
    const [active, setActive] = React.useState(options.findIndex((opt) => opt.selectable !== false));

    const handleClick = (index: number) => {
        setActive(index);
        const option = options[index];
        if (option.action) {
            option.action();
        }
    };

    return (
        <div className={Styles['footer']}>
            {props.children || <React.Fragment>
                <span className={Styles['title']}>{title}</span>
                <ul className={Styles['options']}>
                    {
                        options.map((option: Option, index) => {
                            const liClassName = new ClassNameBuilder(Styles, ['active', index === active]);
                            const click = option.selectable ? () => handleClick(index) : undefined;
                            return <li className={liClassName.toString()} key={index} onClick={click}>{option.name}</li>;
                        })
                    }
                </ul>
                <a href="mailto:support@openfin.co" className={Styles['support']}>
                    <span>Need Help? Get Support</span>
                    <Icon src={supportIcon} size={20}/>
                </a>
            </React.Fragment>
            }
        </div>
    );
};
